import { cn } from '@avanta/shared/utils/cn';

interface SectionProps {
  title?: string | React.ReactNode;
  className?: string;
  containerClassName?: string;
  fullWidth?: boolean;
}

export const StepSection = ({
  title,
  className,
  containerClassName,
  fullWidth = false,
  children,
}: React.PropsWithChildren<SectionProps>): React.ReactElement => (
  <div className={cn('flex flex-col gap-2 am-lg:gap-4', fullWidth && 'w-full', containerClassName)}>
    {title && <h4 className="leading-5 font-medium text-sm am-lg:text-base">{title}</h4>}
    <div className={className}>{children}</div>
  </div>
);
